import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modalityCheckbox", "gpsPriceGroup", "exchangeRateGroup", "serviceCurrency", "equipmentCurrency", "commissionCurrency", "servicePrice", "serviceConversionHint", "equipmentPrice", "equipmentConversionHint", "exchangeRate", "servicePlan", "recurrence", "commissionAmount"]

  connect() {
    this.togglePlanDependents()
    this.toggleGpsPrice()
    this.toggleExchangeRate()
    this.calculateConversion()
  }

  // Precio, periodicidad, GPS y comisión solo se habilitan con un plan elegido
  togglePlanDependents() {
    const hasPlan = this.hasServicePlanTarget && this.servicePlanTarget.value !== ""

    const dependents = [
      this.hasServiceCurrencyTarget && this.serviceCurrencyTarget,
      this.hasServicePriceTarget && this.servicePriceTarget,
      this.hasRecurrenceTarget && this.recurrenceTarget,
      this.hasModalityCheckboxTarget && this.modalityCheckboxTarget,
      this.hasEquipmentCurrencyTarget && this.equipmentCurrencyTarget,
      this.hasEquipmentPriceTarget && this.equipmentPriceTarget,
      this.hasCommissionCurrencyTarget && this.commissionCurrencyTarget,
      this.hasCommissionAmountTarget && this.commissionAmountTarget
    ].filter(Boolean)

    dependents.forEach(el => { el.disabled = !hasPlan })

    if (!hasPlan) {
      if (this.hasServicePriceTarget) this.servicePriceTarget.value = ""
      if (this.hasCommissionAmountTarget) this.commissionAmountTarget.value = ""
      if (this.hasModalityCheckboxTarget && this.modalityCheckboxTarget.checked) {
        this.modalityCheckboxTarget.checked = false
        this.toggleGpsPrice()
      }
    }

    this.calculateConversion()
  }

  toggleGpsPrice() {
    if (this.modalityCheckboxTarget.checked) {
      this.gpsPriceGroupTarget.classList.remove("hidden")
    } else {
      this.gpsPriceGroupTarget.classList.add("hidden")
      const input = this.gpsPriceGroupTarget.querySelector('input')
      if (input) input.value = ""
    }
    this.calculateConversion()
  }

  toggleExchangeRate() {
    // El TC del día vive en un hidden; no hay UI local que mostrar/ocultar.
    if (!this.hasExchangeRateGroupTarget) return

    const hasPen = (this.hasServiceCurrencyTarget && this.serviceCurrencyTarget.value === "PEN") ||
      (this.hasEquipmentCurrencyTarget && this.equipmentCurrencyTarget.value === "PEN") ||
      (this.hasCommissionCurrencyTarget && this.commissionCurrencyTarget.value === "PEN");

    if (hasPen) {
      this.exchangeRateGroupTarget.classList.remove("hidden")
    } else {
      this.exchangeRateGroupTarget.classList.add("hidden")
    }
  }

  calculateConversion() {
    if (!this.hasExchangeRateTarget) return
    const rate = parseFloat(this.exchangeRateTarget.value)
    
    // Service Price Conversion & Validation
    if (this.hasServiceCurrencyTarget && this.hasServicePriceTarget && this.hasServiceConversionHintTarget) {
      const inputCurrency = this.serviceCurrencyTarget.value
      const inputPrice = parseFloat(this.servicePriceTarget.value)
      
      this.serviceConversionHintTarget.classList.remove("text-success", "text-error")
      
      let basePrice = 0;
      let planCurrencySymbol = "$";
      let planCurrencyCode = "USD";

      if (this.hasServicePlanTarget && this.servicePlanTarget.selectedOptions.length > 0) {
        const selectedOption = this.servicePlanTarget.selectedOptions[0];
        const planName = selectedOption.text;
        
        // Find if there is a plan with the same name in the input currency
        let exactMatchOption = null;
        for (let i = 0; i < this.servicePlanTarget.options.length; i++) {
          const opt = this.servicePlanTarget.options[i];
          if (opt.text === planName && opt.dataset.currencyCode === inputCurrency) {
            exactMatchOption = opt;
            break;
          }
        }
        
        const optionToUse = exactMatchOption || selectedOption;
        
        basePrice = parseFloat(optionToUse.dataset.basePrice) || 0;
        planCurrencySymbol = optionToUse.dataset.currency || "$";
        planCurrencyCode = optionToUse.dataset.currencyCode || "USD";
      }

      if (basePrice > 0 && !isNaN(inputPrice) && inputPrice > 0) {
        let normalizedInputPrice = inputPrice;

        // If the currency doesn't match the plan we are comparing against, we convert it
        // This only happens if we didn't find an exact match option above.
        if (inputCurrency !== planCurrencyCode && rate > 0) {
          if (planCurrencyCode === "USD" && inputCurrency === "PEN") {
            normalizedInputPrice = parseFloat((inputPrice / rate).toFixed(2));
          } else if (planCurrencyCode === "PEN" && inputCurrency === "USD") {
            normalizedInputPrice = parseFloat((inputPrice * rate).toFixed(2));
          }
        }

        if (normalizedInputPrice < (basePrice - 0.05)) {
          this.serviceConversionHintTarget.innerHTML = `Precio debajo del mínimo del plan (${planCurrencySymbol}${basePrice.toFixed(2)})`
          this.serviceConversionHintTarget.classList.add("text-error")
          this.serviceConversionHintTarget.classList.remove("hidden")
        } else {
          this.serviceConversionHintTarget.classList.add("hidden")
        }
      } else {
        this.serviceConversionHintTarget.classList.add("hidden")
      }
    }
    
    // Equipment Price Conversion (Removido: solo se muestra en el resumen final)
  }
}
